import { clsx } from 'clsx';
import type { ReactNode } from 'react';

export function PageFooter({ children, className }: { children: ReactNode; className?: string }) {
  return (
    <footer className={clsx('ua-page-footer px-2xl py-xs shrink-0', className)}>{children}</footer>
  );
}
